module.exports = __webpack_public_path__ + "static/media/supplier.19e32ff3.svg";